﻿/* eslint-disable sonarjs/new-cap */
import "../types/globalscope.ts";
// Librairie de gestion des communications avec le site principal. (Côté serveur)
// À utiliser sur le site de la billetterie.
// import type { ComBridgeGetFramePositionMessage, ComBridgeIFrameScrollEventMessage, ComBridgeMessage, ComBridgeMessageAction, ComBridgeResizeMessage, ComBridgeScrollParentToMessage } from "./combridgetypes";
//import "./combridgetypes-global";

// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************
// TODO : FAIRE un fichier de compilation typescript indépendant pour les JS Direct
// *********************************************************
// *********************************************************
// *********************************************************
// *********************************************************

// API Functions **************************************************************




const comBridgeServer_ShowDebugInfo = false; // Reset this in your page if you want to stop it.

// Pour gérer le problème de scroll dans les iframes quand il y a un plugin sur le site web client (scroll-smooth)
let lastScrollPushDate = 0;
document.addEventListener("wheel", sendIFrameScrollWheel);

// Cheap dependencies
// Stephen Morley Queueing tool - http://creativecommons.org/publicdomain/zero/1.0/legalcode
function StephenMorleyQueue() {
    let a=[];
    let b=0;
    this.getLength = function() {
        return a.length-b;
    }, 
    this.isEmpty = function() {
        return 0==a.length;
    },
    this.enqueue=function(b){
        a.push(b);
    },
    this.dequeue=function(){
        if(0!=a.length){
            let c=a[b];
            return 2*++b>=a.length&&(a=a.slice(b),b=0),c;
        }
    },
    this.peek=function(){
        return a.length>0?a[b]:void 0;
    };
}


// Parameter addOnePX can be used when then total size of the body has decimal value like 164.45px. Jquery gives 164 instead of 165 and it doesn't fit the right size on the other end.

// Shortcut that you should call by default to have auto size working
function sendBodySizeToParent(sourceName, addOnePX)
{
    return SendPageSizeToContainerName(sourceName, $('body'), addOnePX);
}

function ComBridge_getNewMessage(action: ComBridgeMessageAction): ComBridgeMessage {
    return {
        action: action,
        frameName: window.name
    };
}

// this must work without jquery because we want it to run before the vendor-libs load.
// @ts-ignore
function ComBridge_prepareMessageForResize(element: HTMLElement | JQuery<any>, msg: ComBridgeResizeMessage, addOnePX: boolean) {
    let height: number; 
    let width: number;
    if (element instanceof HTMLElement){
        height = element.offsetHeight;
        width = element.offsetWidth;
    }
    else {
        height = $(element).innerHeight();
        width = $(element).innerWidth();
    }
    
    if (addOnePX)
        height++;
    
    logToConsole(msg.frameName + " has a height of " + height + " px" + " and a width of " + width + " px");

    msg.height = height + 'px';
    msg.width= width + 'px';

    return msg;
}

function sendIFrameScrollWheel(e: WheelEvent) {
    // if(Date.now() - lastScrollPushDate >= 2000) {
    //     lastScrollPushDate = Date.now();

        var msg = ComBridge_getNewMessage('IFrameScrollWheel') as ComBridgeIFrameScrollEventMessage;

        msg.clientX = e.clientX;
        msg.clientY = e.clientY;
        msg.deltaMode = e.deltaMode;
        msg.deltaX = e.deltaX;
        msg.deltaY = e.deltaY;
        msg.deltaZ = e.deltaZ;
        msg.movementX = e.movementX;
        msg.movementY = e.movementY;
        msg.pageX = e.pageX;
        msg.pageY = e.pageY;
        msg.screenX = e.screenX;
        msg.screenY = e.screenY;
        msg.timeStamp = e.timeStamp;
        msg.type = e.type;
        msg.x = e.x; 
        msg.y = e.y;
        msg.offsetX = e.offsetX; 
        msg.offsetY = e.offsetY;

        // Les champs suivants ne sont pas des champs qui semble exiter dans un monde moderne mais qu'on avait décidé de passer
        // On les ts-ignore dans le but de rester compatible avec les clients.
        // @ts-ignore
        msg.wheelDelta = e.wheelDelta; msg.wheelDeltaX = e.wheelDeltaX; msg.wheelDeltaY = e.wheelDeltaY; e.layerX; msg.layerY = e.layerY;
    
        // Send!
        tryToSendMessage(msg);
    //}
}

// Parameter addOnePX can be used when then total size of the body has decimal value like 164.45px. Jquery gives 164 instead of 165 and it doesn't fit the right size on the other end.
// Source name: name of the item so the parent can identify what it receives
function sendIFrameSizeToParent(element: HTMLElement, addOnePX: boolean, changeHeight: boolean, changeWidth: boolean) {
    let msg = ComBridge_getNewMessage('IFrameSizeChanged') as ComBridgeResizeMessage;

    msg = ComBridge_prepareMessageForResize(element, msg, addOnePX);
    
    if(changeHeight == null)
        changeHeight = true;
    if(changeWidth == null)
        changeWidth = false;

    msg.changeHeight = changeHeight;
    msg.changeWidth = changeWidth;
    
    // Send!
    tryToSendMessage(msg);

    return { width: msg.width, height: msg.height };
}
window.sendIFrameSizeToParent = sendIFrameSizeToParent;

// Parameter addOnePX can be used when then total size of the body has decimal value like 164.45px. Jquery gives 164 instead of 165 and it doesn't fit the right size on the other end.
// Source name: name of the item so the parent can identify what it receives
function sendElementSizeToParent(sourceName: string, element: HTMLElement | JQuery<any>, addOnePX: boolean) {
    let msg = ComBridge_getNewMessage('IFrameHeightChanged') as ComBridgeResizeMessage;

    msg = ComBridge_prepareMessageForResize(element, msg, addOnePX);
    msg.sourceName = sourceName;
    
    // Send!
    tryToSendMessage(msg);

    return { width: msg.width, height: msg.height };
}

//@ts-ignore
function scrollParentTop() { scrollParentTo(0, 0); }
window.scrollParentTop = scrollParentTop;

function scrollParentTo(x: number, y: number){
    let msg = ComBridge_getNewMessage('scrollTo') as ComBridgeScrollParentToMessage;
    msg.x = x;
    msg.y = y;
    
    tryToSendMessage(
        msg
    );
}
window.scrollParentTo = scrollParentTo;


function getFramePosition(headbandClassName: string, cb: (pos: {x: number, y: number}) => void) {

    // Renvoyer au caller: { x: 0, y: 0 }
    let msg = ComBridge_getNewMessage('getFramePosition') as ComBridgeGetFramePositionMessage;
    msg.headbandClassName = headbandClassName;
    
    tryToSendMessage(msg, (msg) => { cb({ x: msg.x, y: msg.y }) });
}
window.getFramePosition = getFramePosition;


//@ts-ignore
function getScrollPosition(cb: (pos: {x: number, y: number}) => void) {

    // Renvoyer au caller: { x: 0, y: 0 }
    let msg = ComBridge_getNewMessage('getScrollPosition');
    
    tryToSendMessage(msg, (msg) => { cb({ x: msg.x, y: msg.y }) });
}
window.getScrollPosition = getScrollPosition;

function RCOMBRIDGE_getWindowSize(cb: (msg: any) => void) {

    // Renvoyer au caller: { x: 0, y: 0 }
    let msg = ComBridge_getNewMessage('getWindowSize');

    tryToSendMessage(msg, (msg) => { cb(msg); });
}


function RCOMBRIDGE_getClientSiteReferrerAndTitle(cb: (msg: any) => void){
    let msg = ComBridge_getNewMessage('getClientSiteReferrerAndTitle');

    tryToSendMessage(msg, (msg) => { cb(msg); });
}
window.RCOMBRIDGE_getClientSiteReferrerAndTitle = RCOMBRIDGE_getClientSiteReferrerAndTitle;

function RCOMBRIDGE_getClientSiteURL(cb: (msg: any) => void) {

    // Renvoyer au caller: le url du browser
    let msg = ComBridge_getNewMessage('getClientSiteURL');

    tryToSendMessage(msg, (msg) => { cb(msg); });
}
window.RCOMBRIDGE_getClientSiteURL = RCOMBRIDGE_getClientSiteURL;


// Get the google analytics cookies so we can use the same on our side so
// the user remains the same guy from the beginning to the conversion.
function RCOMBRIDGE_getTrackingCookies(cb: (msg: any) => void) {

    // Renvoyer au caller: { x: 0, y: 0 }
    let msg = ComBridge_getNewMessage('getTrackingCookies');

    tryToSendMessage(msg, (msg) => { cb(msg); });
}
window.RCOMBRIDGE_getTrackingCookies = RCOMBRIDGE_getTrackingCookies;

// Legacy stuff ***************************************
// Obsolete, use SendElementSizeToParent instead
function SendPageSizeToContainerName(sourceName, containerName, addOnePX) { return sendElementSizeToParent(sourceName, $(containerName), addOnePX).height; }
// Obsolete, use SendBodySizeToParent instead
function SendPageSizeToParent(sourceName, addOnePX) { return sendBodySizeToParent(sourceName, addOnePX); }

// Call a refresh on the small shopping cart IFrame
function RefreshCartIFrame() {
    try {
        let cartIFrame = parent.frames["IFrameReservatechCartPreview"];
        if (cartIFrame !== undefined)
            cartIFrame.RefreshCart();
    } catch (err) {
        logToConsole('Error while refreshing cart : ' + err);
    }
}
window.RefreshCartIFrame = RefreshCartIFrame;
// End legacy stuff ***********************************


// Messaging ******************************************************************

const communicationIFrameName = "easyXDM_Reservatech_provider";
let messageQueue = new StephenMorleyQueue();

// Try to send a message. If it fails, add it to the message queue
function tryToSendMessage(msgToSend: ComBridgeMessage, cb?: (msg: any) => void) {
    const sendRequest = { msg: msgToSend, callback: cb};
    try {
        sendMessage(sendRequest);
        logToConsole('Sending message : ', msgToSend);
    } catch (err) {
        logToConsole('Queuing message : ' , msgToSend);
        messageQueue.enqueue(sendRequest);
    }
}

// Try to send a message. If it fails, add it to the message queue
function queueMessage(msgToSend, cb) {
    var sendRequest = { msg: msgToSend, callback: cb};

    logToConsole('Queuing message : ' , msgToSend);
    messageQueue.enqueue(sendRequest);
}

function sendMessage(sendRequest) {
    parent.frames[communicationIFrameName].SendMessage(sendRequest);
}
window.sendMessage = sendMessage;

function autoSendMessageQueue()
{
    let error = false;
    while (!error && messageQueue.getLength() > 0) {
        let msgToSend = messageQueue.peek();
        try {
            logToConsole('Sending delayed message : ' , msgToSend);
            //alert('Sending late message : ' + msgToSend);
            sendMessage(msgToSend);
            messageQueue.dequeue();
        } catch (err) {
            logToConsole('Error while sending late message' , msgToSend, err);
            error = true; // Prevent from looping. It'll continue looping but using the setTimeout instead so it won't lock the browser.
        }
    }

    setTimeout(autoSendMessageQueue, 500);
}

setTimeout(autoSendMessageQueue, 500);

function logToConsole(text:string, text2?:any, text3?:any) { if (comBridgeServer_ShowDebugInfo) console.log("Reservatech Com -> " , text, text2, text3); }


// Cache d'information global *************************************************
const ComBridge_InfoCache = {
    windowSize: {
        width: 0,
        height: 0
    }
};
window.ComBridge_InfoCache = ComBridge_InfoCache;

let ComBridge_onWindowSizeChanged: (size: { width: number, height: number }) => any;
window.ComBridge_onWindowSizeChanged = ComBridge_onWindowSizeChanged;


function ComBridge_checkWindowSizeChange(){
    RCOMBRIDGE_getWindowSize(ComBridge_afterWindowSizeChanged);
}

function ComBridge_afterWindowSizeChanged(msg) {

    if(ComBridge_InfoCache.windowSize.width != msg.width || ComBridge_InfoCache.windowSize.height != msg.height) {
        ComBridge_InfoCache.windowSize.width = msg.width;
        ComBridge_InfoCache.windowSize.height = msg.height;
        
        if (ComBridge_onWindowSizeChanged) {
            ComBridge_onWindowSizeChanged(ComBridge_InfoCache.windowSize);
        }
    }
}

ComBridge_checkWindowSizeChange();
setInterval(ComBridge_checkWindowSizeChange, 1000);
